/** Only direct, successful server reads may enter this cache. Never cache the
 * Instant optimistic subscription or a submitted draft here. */
const PREFIX = 'halvn:server-snapshot:v1:';

export type ConfirmedSnapshot<T> = { data: T; fetchedAt: number };

export function snapshotKey(appId: string, userId: string, query: unknown) {
  return PREFIX + JSON.stringify([appId, userId, query]);
}

export function readSnapshot<T>(storage: Storage, key: string): ConfirmedSnapshot<T> | undefined {
  try {
    const value = JSON.parse(storage.getItem(key) ?? 'null');
    if (value && typeof value.data === 'object' && value.data !== null
      && Number.isFinite(value.fetchedAt) && value.fetchedAt > 0) return value;
  } catch { /* A corrupt or unavailable cache must not prevent a server read. */ }
}

export function writeSnapshot<T>(storage: Storage, key: string, value: ConfirmedSnapshot<T>) {
  try { storage.setItem(key, JSON.stringify(value)); }
  catch { /* Storage can be disabled or full; the in-memory snapshot still works. */ }
}

export function clearAccountSnapshots(storage: Storage, appId: string, userId: string) {
  try {
    const prefix = PREFIX + JSON.stringify([appId, userId]).slice(0, -1) + ',';
    for (let i = storage.length - 1; i >= 0; i--) {
      const key = storage.key(i);
      if (key?.startsWith(prefix)) storage.removeItem(key);
    }
  } catch { /* Storage may be unavailable. */ }
}
